var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback, quitClaimDeclarationNoConfirm, } from '@declaration/helpers/layoutMetaCallback';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import { Step } from '@shared/claim/steps';
const claim = namespace('claim');
const counting = namespace('counting');
let TenantNotCovered = class TenantNotCovered extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/checklist.svg');
    }
    primaryButtonAction() {
        this.hasPersonalPropertyDamages ? this.nextStep() : quitClaimDeclarationNoConfirm(this);
    }
    async nextStep() {
        await this.updateAndSaveClaimStep(Step.TenantNotCovered);
    }
    get hasPersonalPropertyDamages() {
        if (!this.counting) {
            return false;
        }
        return this.counting.personalProperties.length > 0;
    }
};
__decorate([
    counting.State('counting')
], TenantNotCovered.prototype, "counting", void 0);
__decorate([
    claim.Action('updateAndSaveClaimStep')
], TenantNotCovered.prototype, "updateAndSaveClaimStep", void 0);
TenantNotCovered = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], TenantNotCovered);
export default TenantNotCovered;
